import React from 'react';
import {
  useUpdateSalesforceContactFieldValueMutation,
  SalesforceContactField,
  SalesforceContact,
} from 'api';

interface Props {
  field: SalesforceContactField;
  salesforceContact: SalesforceContact;
}

const Date = ({field, salesforceContact}: Props) => {
  const value = salesforceContact.addition[`${field.fieldName}`];
  const [errorMessage, setErrorMessage] = React.useState('');
  const [updateFieldValue] = useUpdateSalesforceContactFieldValueMutation({
    onCompleted: (data) => {
      setErrorMessage(data.updateSalesforceContactFieldValue.error);
    },
  });

  return (
    <>
      <input
        defaultValue={value}
        className="w-max"
        type="date"
        onBlur={(e) => {
          updateFieldValue({
            variables: {
              salesforceContactId: salesforceContact.id,
              attributes: {fieldName: field.fieldName, value: e.target.value},
            },
          });
        }}
      />
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </>
  );
};

export default Date;
